<template>
  <div v-loading="loading">
    <pt-page-title :title="`${isEdit ? '编辑' :'新建'}视频`">
    </pt-page-title>
    <pt-previous-video-form ref="form" class="pt-previous-video-form__withData"  v-model="currentForm" @isUpload="isUpload"></pt-previous-video-form>
    <div class="button-div">
      <el-button type="primary" @click="save">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import PtPreviousVideoForm from './index'
export default {
  name: 'pt-previous-video-form__withData',
  components: {
    'pt-previous-video-form': PtPreviousVideoForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {},
      isUploading: false
    }
  },
  methods: {
    save () {
      if (this.isUploading) {
        this.$message.error('请等待视频上传完毕再点击')
        return
      }
      this.$refs.form.validate().then(formValue => {
        this.loading = true
        this.isEdit ? this.edit() : this.create()
      })
    },
    changeForm (data) {
      let res = JSON.parse(JSON.stringify(data))
      /* global _ */
      if (_.isObject(res.contentUrl)) {
        res.contentUrl = data.contentUrl.url
      }
      return res
    },
    isUpload (val) {
      this.isUploading = val
    },
    create () {
      let res = this.changeForm(this.currentForm)
      this.$store.dispatch('createdVideo', res).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    edit () {
      let res = this.changeForm(this.currentForm)
      this.$store.dispatch('updateVideo', res).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      this.$store.dispatch('getVideoDetail', this.$route.params.id).then(data => {
        this.currentForm = data.data
        this.loading = false
        console.log('====currentForm', this.currentForm)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    } else {
      var myDate = new Date().getTime()
      this.currentForm = {
        signedDate: myDate
      }
    }
  }
}
</script>
